import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Buffer } from 'buffer';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  currentUser: any;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    }
  }

  getDecodedTokenInfo(accessToken?: string) {
    let token = accessToken;
    if (!token && isPlatformBrowser(this.platformId)) {
      token = JSON.parse(localStorage.getItem("currentUser"))?.token;
    }
    const tokenParts = token.split('.');
    const encodedPayload = tokenParts[1];
    const decodedPayload = Buffer.from(encodedPayload, "base64").toString("ascii");
    const obj = JSON.parse(decodedPayload);
    const roles = obj.RolesAssigned?.split(',');
    
    return {
      roles: [...roles]
    }
  }

}
